import { Box, Tooltip } from "@mantine/core"
import { cloneElement, useId, type MouseEvent, type ReactElement, type ReactNode } from "react"
import classes from "./state-views.module.css"

type Props = Readonly<{
  /** Яагаад боломжгүй вэ (эрхийн код, төлөв). Хоосон бол хяналт хэвийн ажиллана. */
  reason?: ReactNode
  /** Нэг focus авах хяналт: Button, ActionIcon. `disabled` дамжуулахгүй. */
  children: ReactElement<Record<string, unknown>>
}>

/**
 * Идэвхгүй мэт харагддаг ч нуугдаагүй хяналт: `disabled` оронд `aria-disabled`, тиймээс гараар
 * focus авч, tooltip нь hover болон focus дээр нээгдэнэ; шалтгааныг `aria-describedby`-аар унших хэрэгсэлд дамжуулна.
 */
export function ReasonTooltip({ reason, children }: Props) {
  const id = useId()
  if (!reason) return children

  const control = cloneElement(children, {
    "aria-disabled": true,
    "data-disabled": true,
    className: [children.props.className, classes.reasonDisabled].filter(Boolean).join(" "),
    "aria-describedby": id,
    onClick: (event: MouseEvent) => {
      event.preventDefault()
      event.stopPropagation()
    },
  })

  return (
    <>
      <Tooltip label={reason} withArrow events={{ hover: true, focus: true, touch: true }}>
        {control}
      </Tooltip>
      <Box component="span" id={id} className={classes.srOnly}>
        {reason}
      </Box>
    </>
  )
}
